import React, { useRef } from "react";
import "../../assets/styles/bootstrap.css";
import { MapContainer, TileLayer } from "react-leaflet";
import { CEMENTERY_LAT, CEMENTERY_LNG, MAP_ZOOM } from "../../config/defaultValues";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import { CardBody } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import TerraDrawComponent from "../../components/Cementery/TerraDrawComponent";
import { useTranslation } from "react-i18next";

function CementeryPathEditor() {
  const { t } = useTranslation();
  const terraDrawing = useRef();
  const center = {
    lat: CEMENTERY_LAT,
    lng: CEMENTERY_LNG,
  }

  const handleSetMode = (mode) => {
    if (terraDrawing.current) {
      terraDrawing.current.setMode(mode);
      console.log("Set succesful:", mode);
    }
  }

  const handleClear = () => {
    if (terraDrawing.current) {
      terraDrawing.current.clear();
    }
  }

  const handleUpdateDatabase = () => {
    if (terraDrawing.current) {
      terraDrawing.current.updateDatabase();
    }
  }

  const buttons = [
    { text: t("select"), mode: "select" },
    { text: t("line"), mode: "linestring" },
  ];

  console.log("Initializing CPE");

  return (
    <Container fluid className="vh-80">
      <Card className="align-items-center w-100 my-2 m-0">
        <CardBody>
          <Button
            className="m-1"
            variant="primary"
            key="clear"
            onClick={handleUpdateDatabase}
          >
            {t("updateDatabase")}
          </Button>
          {buttons?.map(button => {
            return (
              <Button
                className="m-1"
                variant="outline-dark"
                key={button.text}
                onClick={() => {
                  handleSetMode(button.mode);
                }}
              >
                {button.text}
              </Button>
            )
          })
          }
          <Button
            className="mx-2"
            variant="secondary"
            key="clear"
            onClick={handleClear}
          >
            {t("clear")}
          </Button>
        </CardBody>
      </Card>
      <Card className="w-100 h-100">
        <CardBody className="w-100 h-100">
          <MapContainer
            center={center}
            zoom={MAP_ZOOM}
            className="w-100 h-100"
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <TileLayer
              url="https://jtools.ro/img/map/{z}/{x}/{y}.png"
            />
            <TerraDrawComponent ref={terraDrawing}/>
          </MapContainer>
        </CardBody>
      </Card>
    </Container>
  );
}

export default CementeryPathEditor;
